import axiosInstance from './AxiosInstance';

const API_URL = 'skillcategory';

export const getCategories = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching categories', error);
        throw error;
    }
};

export const getCategoryById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching category with id ${id}`, error);
        throw error;
    }
};

export const createCategory = async (category) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, category);
        return response.data;
    } catch (error) {
        console.error('Error creating category', error);
        throw error;
    }
};

export const updateCategory = async (id, category) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...category });
        return response.data;
    } catch (error) {
        console.error(`Error updating category with id ${id}`, error);
        throw error;
    }
};

export const deleteCategory = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting category with id ${id}`, error);
        throw error;
    }
};

